import { Scissors } from "lucide-react";
import { useLanguage } from "../../context/LanguageContext";
import ToolPage from "./ToolPage";

export default function SplitPDF() {
  const { t } = useLanguage();
  const tk = t.tools.split;


  const config = {
    title: tk.title,
    description: tk.description,
    action: tk.action,
    hint: tk.dropHint,
    hintSub: tk.dropHintSub,
    endpoint: "/pdf/split",
    accept: ".pdf",
    multiple: false,
    resultType: "download",
    resultFileName: tk.result,
    color: "#0891b2",
    Icon: Scissors,
    toolKey: "split",
    extraFields: ({ values, onChange }) => (
      <div className="space-y-4 p-5 bg-slate-50 rounded-xl border border-slate-200">
        <div className="space-y-2">
          <label className="flex items-center gap-3 cursor-pointer group">
            <input
              type="radio"
              name="split_mode"
              value="all"
              checked={(values.mode || "all") === "all"}
              onChange={() => onChange({ ...values, mode: "all" })}
              className="w-4 h-4 accent-blue-600"
              data-testid="split-mode-all"
            />
            <span className="text-sm font-medium text-slate-700 group-hover:text-blue-600 transition-colors">
              {tk.modeAll}
            </span>
          </label>
          <label className="flex items-center gap-3 cursor-pointer group">
            <input
              type="radio"
              name="split_mode"
              value="range"
              checked={(values.mode || "all") === "range"}
              onChange={() => onChange({ ...values, mode: "range" })}
              className="w-4 h-4 accent-blue-600"
              data-testid="split-mode-range"
            />
            <span className="text-sm font-medium text-slate-700 group-hover:text-blue-600 transition-colors">
              {tk.modeRange}
            </span>
          </label>
        </div>

        {(values.mode || "all") === "range" && (
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-1.5">
              {tk.rangeLabel}
            </label>
            <input
              type="text"
              value={values.range_str || ""}
              onChange={(e) => onChange({ ...values, range_str: e.target.value })}
              placeholder={tk.rangePlaceholder}
              data-testid="range-input"
              className="w-full px-4 py-2.5 rounded-lg border border-slate-200 text-sm text-slate-800 focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white"
            />
          </div>
        )}
      </div>
    ),
  };

  return <ToolPage config={config} />;
}
